__turbopack_context__.v({
  "calculator_cta": "calculator-results-module-scss-module__kBTP5G__calculator_cta",
  "chart_wrapper": "calculator-results-module-scss-module__kBTP5G__chart_wrapper",
  "condensed": "calculator-results-module-scss-module__kBTP5G__condensed",
  "cta_wrapper": "calculator-results-module-scss-module__kBTP5G__cta_wrapper",
  "hide_visual": "calculator-results-module-scss-module__kBTP5G__hide_visual",
  "legend_color": "calculator-results-module-scss-module__kBTP5G__legend_color",
  "legend_container": "calculator-results-module-scss-module__kBTP5G__legend_container",
  "legend_item": "calculator-results-module-scss-module__kBTP5G__legend_item",
  "legend_label": "calculator-results-module-scss-module__kBTP5G__legend_label",
  "legend_value": "calculator-results-module-scss-module__kBTP5G__legend_value",
  "results_header": "calculator-results-module-scss-module__kBTP5G__results_header",
  "savings_amount": "calculator-results-module-scss-module__kBTP5G__savings_amount",
  "savings_display": "calculator-results-module-scss-module__kBTP5G__savings_display",
  "savings_period": "calculator-results-module-scss-module__kBTP5G__savings_period",
  "select_wrapper": "calculator-results-module-scss-module__kBTP5G__select_wrapper",
  "tooltip_header": "calculator-results-module-scss-module__kBTP5G__tooltip_header",
  "tooltip_row": "calculator-results-module-scss-module__kBTP5G__tooltip_row",
  "tooltip_summary": "calculator-results-module-scss-module__kBTP5G__tooltip_summary",
});
